import script from "./TesekkurScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./TesekkurScreen.vue?vue&type=script&setup=true&lang=js"

import "./TesekkurScreen.vue?vue&type=style&index=0&id=d8ba5f1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8ba5f1a"]])

export default __exports__